import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Wraps page content so every route change triggers a smooth fade-up + blur-in
 * transition. Also scrolls to top on navigation.
 */
export default function PageTransition({ children }) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div key={location.pathname} className="page-transition" data-testid="page-transition">
      {children}
    </div>
  );
}
